module.exports = __webpack_public_path__ + "img/skill_logo.689be439.png";